import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { message } from "antd";

import { CiCircleChevLeft } from "react-icons/ci";

import { AuthAction } from "../../store/actions";

import LoginLayout from "../../components/layouts/login-layout";
import { Buttons, Spacer, inputFields } from "../../components";

import { Images, Colors } from "../../config";

const VerifySchoolOTP = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const prevData = location.state;

  const [otpCode, setOtpCode] = useState("");

  const handleVerifyCode = () => {
    if (otpCode.length === 0) {
      message.error("Please enter code");
    } else if (otpCode.length < 4 && otpCode.length > 0) {
      message.error("Incomplete Code");
    } else {
      const body = {
        code: otpCode,
        schoolId: prevData?.schoolId,
      };

      dispatch(
        AuthAction.verifySchoolCode(body, (res) => {
          if (res.status === 200) {
            navigate("/signup/password", {
              state: prevData,
            });
          }
        })
      );
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleVerifyCode();
    }
  };
  return (
    <LoginLayout>
      <div className="flex flex-col items-center justify-center px-[6.5em] py-[2.5em] bg-login-gradient gap-4">
        <div className="relative">
          <CiCircleChevLeft
            className="text-[2.5em] absolute -left-[4.175em] top-1 cursor-pointer"
            onClick={() => {
              window.history.back();
            }}
          />
          <img src={Images.UnivisionLogoWithText} className="h-[3.75em]" />
        </div>
        <div className="flex flex-col gap-2 items-center w-full text-center">
          <div className="text-main font-bold text-[2.5em]">School Code</div>
          <div className="text-[1.375em] font-semibold">
            Please enter your 4-digit school code
            <br /> as provided by school admin.
          </div>
        </div>
        <Spacer height={5} />
        <inputFields.CodeInput
          value={otpCode}
          onChange={(e) => setOtpCode(e)}
          onPressEnter={handleKeyDown}
        />

        <Spacer height={5} />

        <Buttons.DefaultButton onClick={handleVerifyCode} width="full">
          Continue
        </Buttons.DefaultButton>
        <div className="flex justify-center items-center font-medium gap-1">
          <div>Haven't received code? </div>
          <div className="text-main font-semibold">
            Please reach out to your counselor!
          </div>
        </div>
      </div>
    </LoginLayout>
  );
};

export default VerifySchoolOTP;
